import Angular from "angular";
import Ionic from "ionic";
import {Keyboard, StatusBar} from "ionic-native";
import GestureDirective from "./modules/core/util/gesture-directive";
import MainModule from "./modules/main/module";

const AppName = 'neonis';

const AppModule = Angular.module(AppName, [
    '$q-spread',
    'ionic',
    'ngMessages',
    'ngResource',
    'ngAnimate',
    'restangular',
    'angular-cache',
    'pascalprecht.translate',
    'angular.bind.notifier',
    'matchMedia',
    MainModule.name
]);

AppModule.directive('onPinch', GestureDirective('onPinch'));
AppModule.directive('onPinchIn', GestureDirective('onPinchIn'));
AppModule.directive('onPinchOut', GestureDirective('onPinchOut'));

Ionic.Platform.ready(() => {
    Ionic.Platform.fullScreen(true, true);

    if (Keyboard) {
        Keyboard.hideKeyboardAccessoryBar(true);
        Keyboard.disableScroll(true);
    }

    if (StatusBar) {
        StatusBar.overlaysWebView(false);
        StatusBar.backgroundColorByHexString('#edede8');
        StatusBar.styleDefault();
    }

    Angular.bootstrap(document, [AppName]);
});





// WEBPACK FOOTER //
// ./src/app.js